import { useState, useCallback } from 'react';
import { BlockInsertionService } from '../services/blockInsertionService';

export const useBlockPlaceholderNavigation = () => {
  const [currentIndex, setCurrentIndex] = useState<number>(0);
  const [totalCount, setTotalCount] = useState<number>(0);

  const refreshCount = useCallback(async () => {
    const count = await BlockInsertionService.countBlockPlaceholders();
    setTotalCount(count);
    if (count === 0) {
      setCurrentIndex(0);
    }
  }, []);

  const navigateToIndex = useCallback(async (index: number) => {
    const success = await BlockInsertionService.navigateToPlaceholder(index);
    if (success) {
      setCurrentIndex(index);
    }
    return success;
  }, []);

  const navigateNext = useCallback(async () => {
    if (totalCount === 0) {
      await refreshCount();
      if (totalCount === 0) return false;
    }

    const nextIndex = (currentIndex + 1) % totalCount;
    return navigateToIndex(nextIndex);
  }, [currentIndex, totalCount, refreshCount, navigateToIndex]);

  const navigatePrevious = useCallback(async () => {
    if (totalCount === 0) {
      await refreshCount();
      if (totalCount === 0) return false;
    }

    const prevIndex = currentIndex === 0 ? totalCount - 1 : currentIndex - 1;
    return navigateToIndex(prevIndex);
  }, [currentIndex, totalCount, refreshCount, navigateToIndex]);

  return {
    currentIndex,
    totalCount,
    refreshCount,
    navigateNext,
    navigatePrevious,
    navigateToIndex
  };
};



